import React, { useState } from "react";

import { Redirect, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { isLoaded, isEmpty, useFirestoreConnect, useFirebase } from 'react-redux-firebase';

import Loading from "../components/Loading";

const UserActivation = () => {
  const {register, handleSubmit} = useForm();
  const { userId } = useParams();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [activationLoading, setActivationLoading] = useState(false);
  const user = useSelector(state => state.firestore?.data?.users && state.firestore?.data?.users[userId])
  const firebase = useFirebase();


  useFirestoreConnect([
    {
      collection: 'users',
      doc: userId
    },
  ]);

  const isValidUser = !isEmpty(user) && !user.isActivated;
  const isLoading = !isLoaded(user) || activationLoading

  const activate = async ({password, passwordConfirmation}) => {
    const activate = firebase.functions().httpsCallable('activateUser');

    setActivationLoading(true);

    if (password !== passwordConfirmation) {
      setError("Passwords don't match")
      setActivationLoading(false);
      return;
    }

    try {
      await activate({ userId, password })
      setSuccess(true);
    } catch ({ message }) {
      setError(message);
    }

    setActivationLoading(false);
  }

  const Form = () => (
    <>
      <h1 className="h3">Complete your signup</h1>
      <p>Choose a password to activate your account.</p>
      <form className="text-left" onSubmit={handleSubmit(activate)}>
        <div className="form-group">
          <label>Password*</label>
          <input type="password" name="password" className="form-control" ref={register}/>
        </div>
        <div className="form-group mb-4">
          <label>Confirm password*</label>
          <input type="password" name="passwordConfirmation" className="form-control" ref={register}/>
        </div>
       { error && (
          <p className="alert alert-warning text-center">
            {error}
          </p>
        )}
        <div className="form-group mb-0">
          <input type="submit" className="btn btn-primary btn-block" value="Continue" />
        </div>
      </form>
    </>
  )

  if (success) {
    return <Redirect to="/login" />
  }

  return (
    <div className="container">
      <a href="https://narratedbypoise.com" className="logo">Poise</a>
      <a href="https://narratedbypoise.com" className="back back-home">
        <i className="fas fa-long-arrow-alt-left"></i>
        &nbsp;
        Back home
      </a>
      <div className="row  justify-content-center text-center mt-5">
        <div className="col-md-12 col-lg-5 col-xl-5 mt-5">
          <div className="card screen reset">
            { isLoading && (
              <Loading />
            )}
            <div className="credentials">
              { !isLoading && !isValidUser && (
                <p className="alert alert-warning text-center">
                  This activation link has already been used
                </p>
              )}
              { !isLoading && isValidUser && (
                <Form />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserActivation;
